import script from "./period-selection-lock-type-dropdown.vue?vue&type=script&lang=ts&setup=true"
export * from "./period-selection-lock-type-dropdown.vue?vue&type=script&lang=ts&setup=true"

import "./period-selection-lock-type-dropdown.vue?vue&type=style&index=0&id=462ca18c&lang=css"

const __exports__ = script;

export default __exports__